import { DateRangePickerDayProps } from '@mui/lab'
import { DateRange } from '@mui/lab/DateRangePicker'
import StaticDateRangePicker from '@mui/lab/StaticDateRangePicker'
import { IDateFilterVar } from 'context'
import { endOfMonth, format, isToday, startOfMonth } from 'date-fns'
import { find } from 'lodash-es'
import { scoreColor } from 'utility'
import { YYYY_MM_DD } from 'utility/timeFormats'
import { useCalendarQuery, useClientConfigQuery } from 'types'
import { DateQuickFilters, getDateRange } from '../helper'
import { DateRangePickerDayStyled } from './styles'

const DEFAULT_SCORE_COLOR = 'transparent'

interface IDateRangeCalendar {
  dateRange: DateRange<Date>
  dayInTheVisibleMonth: Date
  setDayInTheVisibleMonth: (dayInTheVisibleMonth: Date) => void
  changeDate: (selectedQuickFilter: DateQuickFilters, dateFilter: IDateFilterVar) => void
}

export const Calendar = ({
  dateRange,
  changeDate,
  dayInTheVisibleMonth,
  setDayInTheVisibleMonth
}: IDateRangeCalendar) => {
  const { data: clientConfigResult } = useClientConfigQuery()

  const scoreWarningLimit = clientConfigResult?.clientConfig.score.warning
  const scoreDangerLimit = clientConfigResult?.clientConfig.score.danger

  const { data: calendarQueryResult } = useCalendarQuery({
    variables: {
      filter: {
        startDate: startOfMonth(dayInTheVisibleMonth).toString(),
        endDate: endOfMonth(dayInTheVisibleMonth).toString()
      }
    }
  })

  const calendarDailyScores = calendarQueryResult?.calendar?.dates || []

  const renderWeekPickerDay = (
    date: Date,
    dateRangePickerDayProps: DateRangePickerDayProps<Date>
  ) => {
    const formattedDate = format(date, YYYY_MM_DD)
    const dailyScore = find(calendarDailyScores, { date: formattedDate })?.score

    const color = dailyScore
      ? scoreColor(dailyScore, scoreDangerLimit, scoreWarningLimit)
      : DEFAULT_SCORE_COLOR
    return (
      <DateRangePickerDayStyled
        {...dateRangePickerDayProps}
        sx={{
          '& .MuiDateRangePickerDay-day:before': {
            color: color,
            content: `"${dailyScore}"`
          }
        }}
      />
    )
  }

  const handleDateRangeChange = ([from, to]: DateRange<Date>) => {
    if (!from || !to) return
    const nextValue = isToday(from) ? DateQuickFilters.TODAY : DateQuickFilters.DEFINED
    const dateFilter = getDateRange(DateQuickFilters.DEFINED, [from, to])

    changeDate(nextValue, dateFilter)
  }

  return (
    <StaticDateRangePicker
      showToolbar={false}
      value={dateRange}
      onMonthChange={setDayInTheVisibleMonth}
      renderDay={renderWeekPickerDay}
      onChange={handleDateRangeChange}
      renderInput={() => null as any}
    />
  )
}
